// extracted by mini-css-extract-plugin
module.exports = {"body":"announcementBanner_body__cT3VT typography_announcementBanner__3mJoF","link":"announcementBanner_link__BPBsH"};